import React from "react";

const STAGES = [
  "Resolving pull request",
  "Reading changed files",
  "Gathering available product context",
  "Reviewing product impact",
  "Preparing findings",
];

export default function DecisionReviewProgress({ publishing = false }) {
  const stages = publishing ? [...STAGES, "Publishing to GitHub"] : STAGES;
  return (
    <div aria-live="polite" data-testid="decision-review-progress">
      <p>Reviewing this exact commit. You can stay on this page.</p>
      <ol className="rr-progress">
        {stages.map((stage, index) => (
          <li key={stage} aria-current={index === 0 ? "step" : undefined}>
            {stage}
          </li>
        ))}
      </ol>
    </div>
  );
}
